import { createContext, useContext, useEffect, useRef, useState } from "react";
import { adminApi, formatApiError } from "../../../context/AuthContext";

const Context=createContext(null);
export const DraftProvider=Context.Provider;
export const useWizardForm=(name,initial)=>{
  const store=useContext(Context);
  const value=store?.values[name]??initial;
  return [value,next=>store?.set(name,next,initial)];
};

export const useDraftStore=(base,data,setData)=>{
  const [values,setValues]=useState({}),[saving,setSaving]=useState(false),[error,setError]=useState("");
  const valuesRef=useRef({});
  const pending=useRef({}), revision=useRef(0), queue=useRef(Promise.resolve()), timer=useRef(null), initialized=useRef(false);
  const conflict=useRef(false);
  revision.current=data?.application?.revision??revision.current;
  useEffect(()=>{if(data&&!initialized.current){initialized.current=true;valuesRef.current=data.application.wizard_drafts||{};setValues(valuesRef.current);}},[data]);
  const enqueue=task=>{const next=queue.current.catch(()=>{}).then(task);queue.current=next;return next;};
  const flush=()=>enqueue(async()=>{
    clearTimeout(timer.current);
    if(!initialized.current)return true;
    if(conflict.current)return false;
    const entries=Object.entries(pending.current);
    if(!entries.length)return true;
    setSaving(true);setError("");
    try{
      for(const [step,value] of entries){
        const response=await adminApi.put(`${base}/drafts/${step}`,{expected_revision:revision.current,values:value});
        revision.current=response.data.application.revision;setData(response.data);
        if(pending.current[step]===value)delete pending.current[step];
      }
      return true;
    }catch(e){if(e.response?.status===409){conflict.current=true;try{const latest=await adminApi.get(base);revision.current=latest.data.application.revision;setData(latest.data);}catch{}setError("Het dossier is elders gewijzigd. Uw concept is behouden; controleer de actuele gegevens en probeer expliciet opnieuw.");}else setError(formatApiError(e));return false;}finally{setSaving(false);}
  });
  const latestFlush=useRef(flush);latestFlush.current=flush;
  useEffect(()=>{
    const warn=e=>{if(Object.keys(pending.current).length){e.preventDefault();e.returnValue="";}};
    window.addEventListener("beforeunload",warn);
    return()=>{window.removeEventListener("beforeunload",warn);clearTimeout(timer.current);latestFlush.current();};
  },[]);
  const set=(step,next,initial={})=>{const value=typeof next==="function"?next(valuesRef.current[step]??initial):next;valuesRef.current={...valuesRef.current,[step]:value};setValues(valuesRef.current);pending.current[step]=value;clearTimeout(timer.current);timer.current=setTimeout(()=>latestFlush.current(),700);};
  const execute=async task=>{if(!await flush())return false;return enqueue(async()=>{const result=await task(revision.current);if(result?.application)revision.current=result.application.revision;return result;});};
  const recover=async()=>{try{const latest=await adminApi.get(base);revision.current=latest.data.application.revision;setData(latest.data);conflict.current=false;return await flush();}catch(e){setError(formatApiError(e));return false;}};
  return {values,set,saving,error,flush,execute,recover};
};